import { PortalCustomizations, PortalDashboardCustomization, PortalTabsCustomization } from '@/models/customizationModels';

import { RootState } from '../rootReducer';

import { selectPortalCustomizationsCustomization, selectStorefrontCustomization } from './reducers';

export const selectPortalLoginCustomizations = (state: RootState) =>
  state.auth.companyAccount?.customization_uid?.portal_customizations?.login;

const isStorefrontChannel = (state: RootState): boolean => {
  const ch = (state as any)?.layout?.channel || (state as any)?.auth?.channel;
  if (ch) return String(ch).toLowerCase() === 'storefront';
  // Cookie fallback (SSR-safe guard)
  if (typeof document !== 'undefined') return document.cookie.includes('portal_channel=storefront');
  return false;
};

export const selectActiveDashboardCustomization = (state: RootState): Partial<PortalDashboardCustomization> => {
  const storefront = selectStorefrontCustomization(state)?.dashboard;
  const portal = selectPortalCustomizationsCustomization(state)?.dashboard;
  return (isStorefrontChannel(state) ? storefront : portal) || {};
};

export const selectActiveTabsCustomization = (state: RootState): PortalCustomizations['tabs'] => {
  const portalTabs = selectPortalCustomizationsCustomization(state).tabs;
  const storefrontTabs = selectStorefrontCustomization(state)?.tabs;

  if (isStorefrontChannel(state) && storefrontTabs) {
    // merge to apply overrides (like activity_tab_text, show_activity_tab, theme, link_color, show_logout…)
    return { ...portalTabs, ...storefrontTabs };
  }
  return portalTabs;
};
